import { staleTimes, useQuery } from '@platform/api-client';
import type { Operation, ResponseBody, TypedClient } from '@platform/openapi';
import { queryKeys, usePageContext } from '../usePageContext.ts';

export type Subsidiary = ResponseBody<Operation<'/admin/subsidiaries', 'get'>>['items'][number];

type Pickable = { readonly id: string; readonly name: string; readonly archived: boolean };

export const subsidiaryOptions = (subsidiaries: readonly Pickable[], current: string) =>
  subsidiaries
    .filter((subsidiary) => !subsidiary.archived || subsidiary.id === current)
    .map((subsidiary) => ({ value: subsidiary.id, label: subsidiary.name }));

export const useSubsidiaries = (api: TypedClient) => {
  const { tenantId } = usePageContext();
  return useQuery({
    queryKey: queryKeys.subsidiaries(tenantId),
    queryFn: () => api.get('/admin/subsidiaries', {}),
    staleTime: staleTimes.settings,
    select: (data) => data.items,
  });
};
